// "Set state" on a lead (OVERNIGHT-AGENTS-2026-10-03 §3). 88 of 93 consented leads had no leads.state, so every
// second-touch text to them sat in the strictest window (09:00 Pacific - 20:00 Eastern) behind "State unknown —
// confirm before sending". This writes leads.state from a fixed list -- the 50 states + DC, the same codes the
// quiet-hours window maps -- or clears it (blank). Anything else is refused before the write.
import { STATE_TZ } from './quietHours';

export const STATE_CODES = Object.keys(STATE_TZ).sort();   // 51: the 50 states + DC
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function stateError(code) {
  const e = new Error(code);
  e.code = code;
  return e;
}

/** '' / null -> null (clear); 'tx' -> 'TX'; anything not in STATE_CODES throws invalid_state. */
export function normalizeState(value) {
  const s = String(value == null ? '' : value).trim().toUpperCase();
  if (!s) return null;
  if (!STATE_CODES.includes(s)) throw stateError('invalid_state');
  return s;
}

/** Write leads.state for exactly one lead. Returns the row ({id, state}); throws on anything else. */
export async function setLeadState(client, leadId, value) {
  const state = normalizeState(value);
  if (!UUID.test(String(leadId || ''))) throw stateError('bad_lead_id');
  const { data, error } = await client.from('leads').update({ state }).eq('id', leadId).select('id,state');
  if (error) throw error;
  if (!data || data.length !== 1) throw stateError('not_updated');
  return data[0];
}

export const STATE_ERROR_TEXT = {
  invalid_state: 'That is not a US state code. Nothing was changed.',
  bad_lead_id: 'This lead could not be identified. Nothing was changed.',
  not_updated: 'The lead was not updated -- refresh and try again (if you are signed out, sign in first).',
};
